import { Metamodel } from 'app/model/base/model';
import { S3StoreReadSettings } from './s3-store-read-settings';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AmazonS3CompatibleLinkedService } from 'app/model/linkedservice/amazon-s3-compatible.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.amazonS3Compatible.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(AmazonS3CompatibleLinkedService)
    }
})

export class AmazonS3CompatibleStoreReadSettings extends S3StoreReadSettings {
}
